
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersNight as ObiLightRainShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-night.js';
 
 
 

 
 export const ObiLightRainShowersNight = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-night',
   elementClass: ObiLightRainShowersNightElement,
   events: {
     
   }
  });
 
 